type T_Route = "/main" | "/onboard" | "/cardSelect" | "/ocr" | "/ocrResult" | "/face" | "/faceResult" | "/complete";
export type T_Step = { prev: null | T_Route; current: T_Route; next: null | T_Route; label: string };

class PhaseRouter {
  private _step: T_Step[] = [
    { prev: null, current: "/main", next: "/ocr", label: "" },
    { prev: "/main", current: "/onboard", next: "/cardSelect", label: "" },
    { prev: "/onboard", current: "/cardSelect", next: "/ocr", label: "신분증 OCR" },
    { prev: "/cardSelect", current: "/ocr", next: "/ocrResult", label: "신분증 OCR" },
    { prev: "/ocr", current: "/ocrResult", next: "/face", label: "ID OCR 결과" },
    { prev: "/ocrResult", current: "/face", next: "/faceResult", label: "얼굴 LIVENESS" },
    { prev: "/face", current: "/faceResult", next: "/complete", label: "본인확인 결과" },
    { prev: null, current: "/complete", next: "/main", label: "" },
  ];
  private index = 0;

  next() {
    const next = this._step[this.index].next;
    if (next) this.index = (this.index + 1) % this._step.length;
    return this._step[this.index];
  }
  prev() {
    const prev = this._step[this.index].prev;
    if (prev) this.index--;
    return this._step[this.index];
  }

  get step() {
    return this._step[this.index];
  }

  get current() {
    return this._step[this.index].current;
  }

  goToMain() {
    this.index = 0;
  }
}

const phaseRouter = new PhaseRouter();
export default phaseRouter;
